import { createContext } from 'react';

import { Mode } from '@wf/components';

const LicenseModeContext = createContext<Mode>(Mode.create);

export default LicenseModeContext;
